import { render } from "./GenerateProductKeyWordsModal.vue?vue&type=template&id=3c40fcef"
import script from "./GenerateProductKeyWordsModal.vue?vue&type=script&lang=js"
export * from "./GenerateProductKeyWordsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__